<template>
  <div class="unitOfMeasureItemComponentForm">
    <v-form ref="form1" v-model="valid1" lazy-validation>
      <v-layout row>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            :disabled="ID !== 0"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Datum"
              readonly
              @blur="date = parseDate(dateFormatted)"
              :disabled="ID !== 0"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="ID !== 0"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label="Vreme"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="ID !== 0"
            ></v-text-field>
            <v-time-picker
              v-model="time"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-autocomplete
            v-model="operation_select"
            :items="operation_items"
            item-text="name"
            item-value="id"
            label="Operacija"
            persistent-hint
            return-object
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :disabled="ID > 0 && !izmena"
          ></v-autocomplete> </v-flex
        ><v-flex
          xs1
          pa-2
          style="
            padding-top: 20px !important;
            padding-left: 0px !important;
            padding-top: 20px !important;
            max-width: 40px !important;
          "
        >
          <v-icon
            slot="activator"
            @click="otvoriSifarnik"
            style="color: #018389; padding-left: 0px; font-weight: bold"
            title="Dodavanje operacija"
            v-if="ID >= 0 && izmena"
            >add</v-icon
          >
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
              v-model="timeModalNew"
              label="Radnih sati"
              type="number"
              min="0"
              max="60"
              :disabled="!izmena"
              @change="proveraVrednosti"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="temperatura"
            label="Temperatura"
            type="number"
            suffix="°C"
            ref="element4"
            :disabled="ID > 0 && !izmena"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row>
        <v-flex xs4 pa-2>
          <v-autocomplete
            v-model="pruning_select"
            :items="pruning_items"
            item-text="name"
            item-value="id"
            label="Tip rezidbe"
            persistent-hint
            return-object
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            ref="element2"
            :disabled="ID > 0 && !izmena"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-autocomplete
            v-model="breeding_select"
            :items="breeding_items"
            item-text="name"
            item-value="id"
            label="Uzgojni oblik loze"
            persistent-hint
            return-object
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            ref="element3"
            :disabled="ID > 0 && !izmena"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-text-field
            v-model="vremenski_uslovi"
            label="Vremenski uslovi"
            :disabled="ID > 0 && !izmena"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-text-field
            v-model="opis_zasada"
            label="Opis"
            :disabled="ID > 0 && !izmena"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <!-- <v-flex xs4>
          <v-btn @click="submit" class="AppButtonFilled" v-if="izmena"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined" v-if="izmena"
            >odustani</v-btn
          >
        </v-flex> -->
        <v-flex xs4>
          <v-btn @click="submit" class="AppButtonFilled" :disabled="!izmena"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined" v-if="izmena"
            >odustani</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            :disabled="!izmena"
            v-else
            style="border: none !important"
            >odustani</v-btn
          >
        </v-flex>
        <v-flex xs3> </v-flex>

        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_sorti !== 0">
            <p class="gornji_text" v-html="broj_sorti"></p>
            <p class="donji_text" v-html="formatTekstaSorta2(broj_sorti)"></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text">sorti</p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_redova !== 0">
            <p class="gornji_text" v-html="broj_redova"></p>
            <p class="donji_text" v-html="formatTekstaRed2(broj_redova)"></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text">redova</p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_kalemova !== 0">
            <p class="gornji_text" v-html="broj_kalemova"></p>
            <p
              class="donji_text"
              v-html="formatTekstaKalem2(broj_kalemova)"
            ></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text"
            v-html="formatTekstaKalem2(0)"></p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <template v-if="povrsina > 1000">
            <div class="div_prozorce" v-if="broj_sorti !== 0">
              <p
                class="gornji_text"
                v-html="Math.round(povrsina / 100) / 100"
              ></p>
              <p class="donji_text">ha</p>
            </div>
          </template>
          <template v-else-if="povrsina > 0">
            <div class="div_prozorce" v-if="broj_sorti !== 0">
              <p class="gornji_text" v-html="Math.round(povrsina) / 100"></p>
              <p class="donji_text">ar</p>
            </div>
          </template>
          <template v-else>
            <div class="div_prozorce">
              <p class="gornji_text">-</p>
              <p class="donji_text">ar</p>
            </div>
          </template>
        </v-flex>
        <v-flex
          xs1
          pa-2
          v-if="ID > 0"
          style="
            text-align: right !important;
            padding-right: 20px !important;
            padding-top: 5px !important;
          "
        >
          <v-icon
            slot="activator"
            id="FloatingButton"
            @click="otvoriModal_izabrani_redova"
            title="Dodavanje redova"
          ></v-icon>
        </v-flex>
      </v-layout>

      <!-- <v-container style="padding: 10px"> -->
      <div class="DataTable">
        <!-- <v-layout>
              <v-flex xs11 pa-2 style="font-size: 16px !important; padding-left: 5px !important;">
                Spisak zasađenih redova
              </v-flex>
            </v-layout> -->

        <v-layout row wrap id="HeaderRow">
          <v-flex xs2 pa-2> Radna snaga </v-flex>
          <!-- <v-flex xs2 pa-2></v-flex> -->
          <v-flex xs8 pa-2></v-flex>
          <v-flex
            xs2
            pa-2
            style="text-align: right !important; padding-right: 30px !important"
            v-if="ID > 0 && izmena"
          >
            <img
              class="DataTable__Button"
              title="Dodavanje radne snage"
              src="../assets/icons/zatabele/ico-add.svg"
              alt="add-item"
              @click="otvoriModal_izbor_radne_snage"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 style="overflow: auto">
            <v-data-table
              item-key="rowId"
              :headers="headers_radna_snaga"
              :items="objVineyardOperationWorkForces"
              hide-actions
              class="topics"
              show-select
              dense
              select-all
              :pagination.sync="pagination"
              ><template slot="headers" slot-scope="props_modal">
                <tr style="border: none">
                  <th
                    style="text-align: center; padding: 5px"
                    v-for="header in props_modal.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props_modal">
                <tr>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="props_modal.item.employee !== null"
                  >
                    <template
                      v-if="props_modal.item.employee.firstName !== null"
                    >
                      {{
                        props_modal.item.employee.firstName +
                        " " +
                        props_modal.item.employee.lastName
                      }}
                    </template>
                    <template v-else>
                      {{ props_modal.item.employee.name }}
                    </template>
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else-if="props_modal.item.vineyardOperationWorkForceInGroups.length === 1"
                  >
                  {{
                        props_modal.item.vineyardOperationWorkForceInGroups[0].employee.firstName +
                        " " +
                        props_modal.item.vineyardOperationWorkForceInGroups[0].employee.lastName
                      }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else-if="props_modal.item.vineyardOperationWorkForceInGroups.length > 1"
                  >
                  {{ props_modal.item.vineyardOperationWorkForceInGroups.length + ' radnika' }}
                    <template
                    >
                      <v-menu
                        open-on-hover
                        top
                        offset-x
                        nudge-right="20"
                        close-delay="100"
                      >
                        <template v-slot:activator="{}">
                          <v-icon
                            slot="activator"
                            small
                            class="ml-2"
                            color="teal"
                          >
                            info
                          </v-icon>
                          <span>
                            <v-container style="background-color: white">
                              <div class="DataTable">
                                <v-layout column>
                                  <v-flex style="overflow: auto">
                                    <v-data-table
                                      :headers="headers_modal_izabrani_tankovi"
                                      :items="
                                        props_modal.item.vineyardOperationWorkForceInGroups
                                      "
                                      hide-actions
                                      class="elevation-1"
                                      show-select
                                      dense
                                      select-all
                                      :pagination.sync="pagination"
                                    >
                                      <template
                                        slot="headers"
                                        slot-scope="props_modal"
                                      >
                                        <tr>
                                          <th
                                            style="
                                              text-align: center;
                                              padding: 5px;
                                            "
                                            v-for="header in props_modal.headers"
                                            :key="header.text"
                                          >
                                            {{ header.text }}
                                          </th>
                                        </tr>
                                      </template>
                                      <template
                                        slot="items"
                                        slot-scope="props_modal"
                                      >
                                        <tr>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                          >
                                            {{
                                              props_modal.item.employee.firstName + " " + props_modal.item.employee.lastName
                                            }}
                                          </td>
                                        </tr>
                                      </template>
                                    </v-data-table>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-container>
                          </span>
                        </template>
                      </v-menu>
                    </template>
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-else-if="
                      props_modal.item.externalFirstName !== null &&
                      props_modal.item.externalLastName !== null
                    "
                  >
                    {{
                      props_modal.item.externalFirstName +
                      " " +
                      props_modal.item.externalLastName
                    }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-else-if="props_modal.item.externalFirstName !== null"
                  >
                    {{ props_modal.item.externalFirstName }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td
                    style="text-align: center; padding-left: 30px"
                    v-if="props_modal.item.duration !== null"
                  >
                    {{ convertMinToTime(props_modal.item.duration) }} h
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td
                    style="text-align: center; padding-left: 30px"
                  >
                  {{
                      (props_modal.item.executed !== "0" && props_modal.item.executed !== null ? props_modal.item.executed + " ha" : "-")
                    }}
                  </td>
                  <td
                    style="text-align: center; padding-left: 30px"
                    v-if="props_modal.item.workersInGroup !== null"
                  >
                    {{ props_modal.item.workersInGroup }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-if="
                      props_modal.item.price !== null &&
                      props_modal.item.currency !== null
                    "
                  >
                    {{
                      props_modal.item.price +
                      " " +
                      props_modal.item.currency.mark
                    }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-else-if="props_modal.item.price !== null"
                  >
                    {{ props_modal.item.price }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td class="DataTable__ButtonHolder">
                    <img
                      class="DataTable__Button"
                      title="Izmena"
                      src="../assets/icons/zatabele/ico-edit2.svg"
                      alt="ulaz-grozdja"
                      @click="editItemRS(props_modal.item)"
                      v-if="izmena"
                    />
                    <img
                      class="DataTable__Button"
                      title="Pregled"
                      src="../assets/icons/zatabele/ico-view.png"
                      alt="ulaz-grozdja"
                      @click="editItemRS(props_modal.item)"
                      v-else
                    />
                    <img
                      class="DataTable__Button"
                      title="Brisanje"
                      src="../assets/icons/zatabele/ico-delete2.svg"
                      alt="delete-item"
                      @click="deleteRS(props_modal.item)"
                      v-if="izmena"
                    />
                  </td>
                </tr>
              </template>

              <template slot="no-data">
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="primary"
                  icon="info"
                  >Nema podataka.</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap id="HeaderRow">
          <v-flex xs4 pa-2> Mehanizacija </v-flex>
          <v-flex
            xs2
            pa-2
            style="text-align: right !important; padding-right: 30px !important"
            v-if="ID > 0 && izmena"
          >
            <img
              class="DataTable__Button"
              title="Dodavanje mehanizacije"
              src="../assets/icons/zatabele/ico-add.svg"
              alt="add-item"
              @click="otvoriModal_izbor_mehanizacije"
            />
          </v-flex>
          <v-flex xs2 v-else> </v-flex>
          <v-flex xs4 pa-2 style="padding-left: 20px !important">
            Repromaterijal
          </v-flex>
          <v-flex
            xs2
            pa-2
            style="text-align: right !important; padding-right: 30px !important"
            v-if="ID > 0 && izmena"
          >
            <img
              class="DataTable__Button"
              title="Dodavanje materijala"
              src="../assets/icons/zatabele/ico-add.svg"
              alt="add-item"
              @click="otvoriModal_izbor_materijala"
            />
          </v-flex>
          <v-flex xs2 v-else> </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6 style="overflow: auto">
            <v-data-table
              item-key="rowId"
              :headers="headers_mehanizacija"
              :items="objVineyardOperationMechanizations"
              hide-actions
              class="topics"
              show-select
              dense
              select-all
              :pagination.sync="paginationMehanizacija"
              style="border: none !important"
              ><template slot="headers" slot-scope="props_modal">
                <tr style="border: none">
                  <th
                    style="text-align: center; padding: 5px"
                    v-for="header in props_modal.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      paginationMehanizacija.descending ? 'desc' : 'asc',
                      header.value === paginationMehanizacija.sortBy
                        ? 'active'
                        : '',
                    ]"
                    @click="changeSortMehanizacija(header.value)"
                  >
                    <v-icon>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props_modal">
                <tr>
                  <td
                    style="text-align: center; padding: 5px"
                    v-if="props_modal.item.mechanization !== null"
                  >
                    <template
                      v-if="props_modal.item.mechanization.name !== null"
                    >
                      {{ props_modal.item.mechanization.name }}
                    </template>
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-else-if="
                      props_modal.item.externalMechanizationName !== null
                    "
                  >
                    {{ props_modal.item.externalMechanizationName }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-if="props_modal.item.driver !== null"
                  >
                    {{
                      props_modal.item.driver.firstName +
                      " " +
                      props_modal.item.driver.lastName
                    }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-else-if="
                      props_modal.item.externalMachinistLastName !==
                        undefined &&
                      props_modal.item.externalMachinistLastName !== null
                    "
                  >
                    {{
                      props_modal.item.externalMachinistFirstName +
                      " " +
                      props_modal.item.externalMachinistLastName
                    }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ props_modal.item.externalMachinistFirstName }}
                  </td>
                  <td
                    style="text-align: center; padding-left: 30px"
                  >
                  {{
                      (props_modal.item.executed !== "0" && props_modal.item.executed !== null ? props_modal.item.executed + " ha" : "-")
                    }}
                  </td>

                  <td
                    style="text-align: center; padding: 5px"
                    v-if="
                      props_modal.item.currency !== null &&
                      props_modal.item.currency !== undefined &&
                      props_modal.item.price !== null &&
                      props_modal.item.price !== undefined
                    "
                  >
                    {{
                      props_modal.item.price +
                      (props_modal.item.fuelConsumption !== null &&
                      props_modal.item.fuelConsumption !== undefined &&
                      props_modal.item.fuelPrice !== null &&
                      props_modal.item.fuelPrice !== undefined
                        ? props_modal.item.fuelConsumption *
                            props_modal.item.fuelPrice +
                          (props_modal.item.driverPrice !== null
                            ? Number(props_modal.item.driverPrice)
                            : 0)
                        : 0) +
                      " " +
                      props_modal.item.currency.mark
                    }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-else-if="
                      props_modal.item.currency === null ||
                      props_modal.item.currency === undefined
                    "
                  >
                    {{
                      props_modal.item.price +
                      (props_modal.item.fuelConsumption !== null &&
                      props_modal.item.fuelConsumption !== undefined &&
                      props_modal.item.fuelPrice !== null &&
                      props_modal.item.fuelPrice !== undefined
                        ? props_modal.item.fuelConsumption *
                          props_modal.item.fuelPrice
                        : 0) +
                      (props_modal.item.driverPrice !== null
                        ? Number(props_modal.item.driverPrice)
                        : 0) +
                      " " +
                      (props_modal.item.fuelCurrency !== null ||
                      props_modal.item.fuelCurrency !== undefined
                        ? props_modal.item.fuelCurrency.mark
                        : "")
                    }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-else-if="
                      props_modal.item.price === null ||
                      props_modal.item.price === undefined
                    "
                  >
                    {{
                      (((props_modal.item.fuelConsumption  !== null
                            ? props_modal.item.fuelConsumption : 0) *
                            (props_modal.item.fuelPrice  !== null
                            ? props_modal.item.fuelPrice : 0) +
                          (props_modal.item.driverPrice !== null
                            ? Number(props_modal.item.driverPrice)
                            : 0)) != 0
                        ? (props_modal.item.fuelConsumption  !== null
                            ? props_modal.item.fuelConsumption : 0) *
                            (props_modal.item.fuelPrice  !== null
                            ? props_modal.item.fuelPrice : 0) +
                          (props_modal.item.driverPrice !== null
                            ? Number(props_modal.item.driverPrice)
                            : 0)
                        : "-") +
                      " " +
                      props_modal.item.currency.mark
                    }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td
                    class="DataTable__ButtonHolder"
                    style="padding-left: 0px !important"
                  >
                    <img
                      class="DataTable__Button"
                      title="Izmena"
                      src="../assets/icons/zatabele/ico-edit2.svg"
                      alt="ulaz-grozdja"
                      @click="editItemMeh(props_modal.item)"
                      v-if="izmena"
                    />
                    <img
                      class="DataTable__Button"
                      title="Pregled"
                      src="../assets/icons/zatabele/ico-view.png"
                      alt="ulaz-grozdja"
                      @click="editItemMeh(props_modal.item)"
                      v-else
                    />
                    <img
                      class="DataTable__Button"
                      title="Brisanje"
                      src="../assets/icons/zatabele/ico-delete2.svg"
                      alt="delete-item"
                      @click="deleteMeh(props_modal.item)"
                      v-if="izmena"
                    />
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="primary"
                  icon="info"
                  >Nema podataka.</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs6 style="overflow: auto">
            <v-data-table
              item-key="rowId"
              :headers="headers_utrosak_materijala"
              :items="objMaterialFromWarehouseDocumentItems"
              hide-actions
              class="topics"
              show-select
              dense
              select-all
              :pagination.sync="paginationMaterijal"
              ><template slot="headers" slot-scope="props_modal">
                <tr style="border: none">
                  <th
                    style="text-align: center; padding: 5px"
                    v-for="header in props_modal.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      paginationMaterijal.descending ? 'desc' : 'asc',
                      header.value === paginationMaterijal.sortBy
                        ? 'active'
                        : '',
                    ]"
                    @click="changeSortMaterijal(header.value)"
                  >
                    <v-icon>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props_modal">
                <tr>
                  <td
                    style="text-align: center; padding: 5px"
                    v-if="
                      props_modal.item.additive !== null &&
                      props_modal.item.additive !== undefined
                    "
                  >
                    {{ props_modal.item.additive.name }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-if="
                      props_modal.item.quantity !== null &&
                      props_modal.item.unitOfMeasure !== null
                    "
                  >
                    {{
                      props_modal.item.quantity +
                      " " +
                      props_modal.item.unitOfMeasure.mark.replace("psc", "kom")
                    }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-else-if="props_modal.item.unitOfMeasure === null"
                  >
                    {{ props_modal.item.quantity }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-if="props_modal.item.value !== null"
                  >
                    {{ props_modal.item.value }} RSD
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td
                    class="DataTable__ButtonHolder"
                    style="padding-left: 0px !important"
                  >
                    <img
                      class="DataTable__Button"
                      title="Izmena"
                      src="../assets/icons/zatabele/ico-edit2.svg"
                      alt="ulaz-grozdja"
                      @click="editItemMat(props_modal.item)"
                      v-if="izmena"
                    />
                    <img
                      class="DataTable__Button"
                      title="Pregled"
                      src="../assets/icons/zatabele/ico-view.png"
                      alt="ulaz-grozdja"
                      @click="editItemMat(props_modal.item)"
                      v-else
                    />
                    <img
                      class="DataTable__Button"
                      title="Brisanje"
                      src="../assets/icons/zatabele/ico-delete2.svg"
                      alt="delete-item"
                      @click="deleteMat(props_modal.item)"
                      v-if="izmena"
                    />
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="primary"
                  icon="info"
                  >Nema podataka.</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </div>
      <!-- </v-container> -->
    </v-form>

    <v-dialog
      v-model="dialogNote_izbor_radne_snage"
      scrollable
      content-class="ModalInModalVineyardRows"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <MyComponent
              @newdata="handleData($event)"
              @close="handleDataClose($event)"
              :articleId="id_vineyard_rs"
              :ID="ID_rs"
              :plaintObject="objVineyardPlaintPom"
              :vineyardOperationExecution="objVineyardOperationExecutionPom"
              :item="izabrani_red_rs_pom"
              :edit="izmena"
            ></MyComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_operacije"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <VineyardOperation
              @close="handleDataCloseOperacije($event)"
              :operationType="operacija"
            ></VineyardOperation>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_izbor_mehanizacije"
      scrollable
      content-class="ModalInModalVineyardRows"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <MyComponentMehanizacija
              @newdata="handleDataMehanizacija($event)"
              @close="handleDataCloseMehanizacija($event)"
              :articleId="id_vineyard_meh"
              :ID="ID_meh"
              :plaintObject="objVineyardPlaintPom_meh"
              :vineyardOperationExecution="objVineyardOperationExecutionPom"
              :item="izabrani_red_meh_pom"
              :edit="izmena"
              :berba="false"
            ></MyComponentMehanizacija>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_izbor_materijala"
      scrollable
      content-class="ModalInModal"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <MyComponentMaterial
              @newdata="handleDataMaterial($event)"
              @close="handleDataCloseMaterial($event)"
              :articleId="id_vineyard_mat"
              :ID="ID_mat"
              :plaintObject="objVineyardPlaintPom"
              :vineyardOperationExecution="objVineyardOperationExecutionPom"
              :item="izabrani_red_mat_pom"
              :edit="izmena"
            ></MyComponentMaterial>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_izabrani_redovi"
      scrollable
      content-class="ModalInModalVineyardRows"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <MyComponentVineYardRows
              @newdata="handleDataVineyardRows($event)"
              @close="handleDataCloseVineyardRows($event)"
              :vineyardId="id_vineyard_pom"
              :ID="ID"
              :plaintObject="objVineyardPlaintPom"
              :vineyardOperationExecution="objVineyardOperationExecutionPom"
              :datumOperacije="datum_operacije"
              :izmena="izmena"
            ></MyComponentVineYardRows>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON, daLiJeVinarija } from "../helpers/Functions";
import TokenComponent from "../components/Token";

import MyComponent from "./VineyardOperationWorkForcesComponent";
import MyComponentMehanizacija from "./VineyardOperationMechanizationsComponent.vue";
import MyComponentMaterial from "./VineyardOperationMaterialComponent.vue";
import MyComponentVineYardRows from "./VineyardOperationVineYardRowsComponent.vue";

import VineyardOperation from "../views/VineyardOperationVinogradi.vue";

export default {
  name: "VineYardManualWorkComponent",
  components: {
    TokenComponent,
    MyComponent,
    MyComponentMehanizacija,
    MyComponentMaterial,
    MyComponentVineYardRows,

    VineyardOperation,
  },
  data: () => ({
    pagination: {
      sortBy: "name",
      rowsPerPage: 10000000,
    },
    paginationMaterijal: {
      sortBy: "name",
      rowsPerPage: 10000000,
    },
    paginationMehanizacija: {
      sortBy: "name",
      rowsPerPage: 10000000,
    },
    search: "",

    valid: true,
    valid1: true,
    ID: 0,
    ID_grape_variety: 0,
    ID_reda: 0,
    redni_broj: "",
    povrsina: 0,
    opis: "",
    opis_zasada: "",
    tip_zemljista: "",
    plantNumberFrom: undefined,
    plantNumber: undefined,

    polozaj: "",
    sastav_tla: "",
    operation_select: undefined,
    distanceBetweenRows: undefined,
    dateFormatted: null,
    menu: "",
    time: "",
    date: null,
    menuModal: "",
    menuModal2: "",
    dialogNote_izabrani_redovi: false,
    dialogNote_izbor_radne_snage: false,
    dialogNote_izbor_mehanizacije: false,
    headers_modal_zasadjeni_redovi: [
      { text: "Datum", value: "date", align: "left" },
      { text: "Sorta", value: "weatherConditions", align: "left" },
      { text: "Operacija", value: "vineyardOperation.name", align: "left" },
      { text: "" },
    ],
    headers_radna_snaga: [
      { text: "Radnik", value: "Name" },
      { text: "Trajanje", value: "duration" },
      { text: "Urađeno", value: "executed" },
      { text: "Grupa", value: "workersInGroup" },
      { text: "Iznos", value: "price" },
      { text: " " },
    ],
    headers_mehanizacija: [
      { text: "Masina", value: "Name" },
      { text: "Vozac", value: "driver" },
      { text: "Urađeno", value: "executed" },
      { text: "Iznos", value: "price" },
      { text: " " },
    ],
    headers_utrosak_materijala: [
      { text: "Materijal", value: "Name" },
      { text: "Količina", value: "duration" },
      { text: "Vrednost", value: "duration" },
      { text: " " },
    ],
    headers_modal_izabrani_tankovi: [
      { text: "Spisak radnika", value: "tankNumberInBatch", align: "center" }
    ],
    id_vineyard: 0,
    id_vineyard_pom: undefined,
    objVineyardOperationExecutionPom: {},
    id_vineyard_block: 0,
    operation_items: [],
    objVineyardPlaint: [],
    objVineyardOperationExecution: {},
    objVineyardOperationWorkForces: [],
    objVineyardOperationWorkForcesSave: [],
    objVineyardOperationMechanizations: [],
    objVineyardOperationMechanizationsSave: [],
    objMaterialFromWarehouseDocumentItems: [],
    objMaterialFromWarehouseDocumentItemsSave: [],
    objVineyardOperationRows: [],
    izmena: false,
    od_cokota_red: undefined,
    broj_cokota_red: undefined,
    opis_red: undefined,
    naslov_izmena_reda: "",
    sufiks: "",
    pomFromNew: undefined,
    pomFromTo: undefined,
    prvi_prolaz: true,
    dialogNote_izbor_materijala: false,
    temperatura: undefined,
    vremenski_uslovi: undefined,
    time: "",
    menu1: "",
    pomFromNew2: undefined,
    objVineyardOperationBlock: [],
    objVineyardOperationTables: [],
    timeModalNew: "",
    menuModal2New: "",
    duration: undefined,
    izabrani_red_mat: undefined,
    izabrani_red_meh: undefined,
    izabrani_red_rs: undefined,

    povrsina: 0,
    broj_sorti: 0,
    broj_redova: 0,
    broj_kalemova: 0,

    dialogNote_operacije: false,
    operacija: undefined,

    datum_operacije: undefined,
    objVineyardPlaintPom: undefined,
    objVineyardPlaintPom_meh: undefined,
    izabrani_red_mat_pom: undefined,
    izabrani_red_meh_pom: undefined,
    izabrani_red_rs_pom: undefined,
    ID_meh: 0,
    ID_rs: 0,
    ID_mat: 0,
    id_vineyard_meh: undefined,
    id_vineyard_rs: undefined,
    id_vineyard_mat: undefined,

    pruning_select: undefined,
    breeding_select: undefined,
    pruning_items: [],
    breeding_items: [],
    lokVinarija: undefined,

tekstBiljka: "",
vinarija: true,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    proveraVrednosti(e){
      this.timeModalNew.replace('-', '');
      if(e < 0){
        alert("Trajanje ne može biti manje od nule.");
        this.timeModalNew = 0;
      }
    },
    preracunajBrojCokota(objekat) {
      let odgovor = 0;
      objekat.forEach(function (entry) {
        odgovor =
          odgovor + entry.executedNumberTo - entry.executedNumberFrom + 1;
      });

      return odgovor;
    },
    otvoriSifarnik(event) {
      this.operacija = "Rezidba";
      this.dialogNote_operacije = true;
    },
    editItemRS(item) {
      this.izabrani_red_rs = item;
      this.otvoriModal_izbor_radne_snage();
    },
    editItemMeh(item) {
      this.izabrani_red_meh = item;
      this.otvoriModal_izbor_mehanizacije();
    },
    editItemMat(item) {
      this.izabrani_red_mat = item;
      this.otvoriModal_izbor_materijala();
    },
    deleteRS(item) {
      confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
        this.deleteSifarnikPom(item.id, "work_force");
    },
    deleteMeh(item) {
      confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
        this.deleteSifarnikPom(item.id, "mechanization");
    },
    deleteMat(item) {
      confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
        this.deleteSifarnikPom(item.id, "material");
    },
    formatTekstaSorta2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "sorte";
      else tekst = "sorti";

      return tekst;
    },
    formatTekstaKalem2(broj) {
      let tekst = "";

      if (this.vinarija){
        if (broj % 10 === 1 && broj !== 11) tekst = "čokot";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "čokota";
        else tekst = "čokota";
      }
      else {
        if (broj % 10 === 1 && broj !== 11) tekst = "biljka";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "biljke";
        else tekst = "biljaka";        
      };

      return tekst;
    },
    formatTekstaRed2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "reda";
      else tekst = "redova";

      return tekst;
    },
    deleteSifarnikPom(id, sta_se_brise) {
      this.$http
        .delete(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/" +
            sta_se_brise +
            "/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllSifarnikInit(this.ID);
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/" +
                        sta_se_brise +
                        "/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllSifarnikInit(this.ID);
                      this.clear();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    convertTimeToMinute(locTime) {
      //let pomArray = locTime.toString().split(":");
      
      //var minutes = Number(pomArray[0]) * 60 + Number(pomArray[1]);
      var minutes = locTime * 60;

      return minutes;
    },
    convertMinToTime(locMinutes) {
      return locMinutes / 60;
    },
    changeSufix(e) {
      this.sufiks = "kom";
    },
    changeGrapeVariety(e) {
      if (e !== undefined) {
        this.ID_grape_variety = e.id;
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    changeSortMaterijal(column) {
      if (this.paginationMaterijal.sortBy === column) {
        this.paginationMaterijal.descending =
          !this.paginationMaterijal.descending;
      } else {
        this.paginationMaterijal.sortBy = column;
        this.paginationMaterijal.descending = false;
      }
    },
    changeSortMehanizacija(column) {
      if (this.paginationMehanizacija.sortBy === column) {
        this.paginationMehanizacija.descending =
          !this.paginationMehanizacija.descending;
      } else {
        this.paginationMehanizacija.sortBy = column;
        this.paginationMehanizacija.descending = false;
      }
    },
    handleData: function (e) {
      this.dialogNote_izbor_radne_snage = false;
    },
    handleDataClose: function (e) {
      this.izabrani_red_rs = undefined;
      this.izabrani_red_rs_pom = undefined;

      // this.objVineyardOperationWorkForces = e.show;
      // this.objVineyardOperationWorkForcesSave = e.save;

      // // if (this.ID !== 0) this.getAllSifarnikInit(this.ID);
      // this.objVineyardOperationExecution.vineyardOperationWorkForces = e.show;
      // this.objVineyardPlaint.vineyardOperationWorkForces = e.show;

      this.getAllSifarnikInit(this.ID);

      this.dialogNote_izbor_radne_snage = false;
    },
    handleDataMehanizacija: function (e) {
      this.dialogNote_izbor_mehanizacije = false;
    },
    handleDataCloseOperacije: function (e) {
      

      this.getAllOperations(e.name);
      this.dialogNote_operacije = false;
    },
    handleDataCloseMehanizacija: function (e) {
      this.izabrani_red_meh_pom = undefined;
      this.izabrani_red_meh = undefined;

      this.objVineyardPlaintPom_meh = undefined;
      this.id_vineyard_pom = undefined;
      this.objVineyardOperationExecutionPom = undefined;

      this.objVineyardOperationMechanizations = e.show;
      this.objVineyardOperationMechanizationsSave = e.save;

      // if (this.ID !== 0) this.getAllSifarnikInit(this.ID);
      this.objVineyardOperationExecution.vineyardOperationMechanizations =
        e.show;
      this.objVineyardPlaint.vineyardOperationMechanizations = e.show;

      this.dialogNote_izbor_mehanizacije = false;
    },
    handleDataMaterial: function (e) {
      this.dialogNote_izbor_materijala = false;
    },
    handleDataCloseMaterial: function (e) {
      this.izabrani_red_mat = undefined;

      this.objMaterialFromWarehouseDocumentItems = e.show;
      this.objMaterialFromWarehouseDocumentItemsSave = e.save;

      // if (this.ID !== 0) this.getAllSifarnikInit(this.ID);
      this.objVineyardOperationExecution.vineyardOperationMaterials = e.show;

      this.dialogNote_izbor_materijala = false;
    },
    otvoriModal_izabrani_redova() {
      this.id_vineyard_pom = this.id_vineyard;
      this.objVineyardOperationExecutionPom =
        this.objVineyardOperationExecution;
      this.objVineyardPlaintPom = this.objVineyardPlaint;

      this.dialogNote_izabrani_redovi = true;
    },
    otvoriModal_izbor_radne_snage() {
      this.id_vineyard_rs = this.id_vineyard;
      this.ID_rs = this.ID;
      this.objVineyardPlaintPom = this.objVineyardPlaint;
      this.objVineyardOperationExecutionPom =
        this.objVineyardOperationExecution;
      this.izabrani_red_rs_pom = this.izabrani_red_rs;

      this.dialogNote_izbor_radne_snage = true;
    },
    otvoriModal_izbor_mehanizacije() {
      this.id_vineyard_meh = this.id_vineyard;
      this.ID_meh = this.ID;
      this.objVineyardPlaintPom_meh = this.objVineyardPlaint;
      this.objVineyardOperationExecutionPom =
        this.objVineyardOperationExecution;
      this.izabrani_red_meh_pom = this.izabrani_red_meh;

      this.dialogNote_izbor_mehanizacije = true;
    },
    otvoriModal_izbor_materijala() {
      this.id_vineyard_mat = this.id_vineyard;
      this.ID_mat = this.ID;
      this.objVineyardPlaintPom = this.objVineyardPlaint;
      this.objVineyardOperationExecutionPom =
        this.objVineyardOperationExecution;
      this.izabrani_red_mat_pom = this.izabrani_red_mat;

      this.dialogNote_izbor_materijala = true;
    },

    handleDataVineyardRows: function (e) {
      // this.dialogNote_izabrani_redovi = false;
    },
    handleDataCloseVineyardRows: function (e) {
      this.dialogNote_izabrani_redovi = false;
      this.objVineyardOperationRows = [];
      this.objVineyardPlaintPom = undefined;
      this.id_vineyard_pom = undefined;
      this.objVineyardOperationExecutionPom = undefined;

      if (this.ID > 0) {
        this.getAllSifarnikInit(this.ID);
        // this.clear();
      }
      // let pomObj;
      // let _this = this;

      // let rows = e.rows;
      // let blocks = e.blocks;

      // this.povrsina = 0;

      // rows.forEach(function (entry) {
      //   let lokID;

      //   lokID = entry.id_pom.split("_")[0];

      //   if (
      //     entry.vineyardOperationExecutionId !== undefined &&
      //     entry.vineyardOperationExecutionId !== null
      //   )
      //     pomObj = {
      //       executedNumberFrom: entry.executedNumberFrom,
      //       executedNumberTo: entry.executedNumberTo,
      //       id: entry.vineyardOperationExecutionId,
      //       vineyardRow: {
      //         id: lokID,
      //       },
      //       description: "",
      //       harvestGrapeConditions: null,
      //       harvestQuantity: null,
      //       harvestQuantityPerPlant: null,
      //       harvestSugarInGrape: null,
      //       harvestSugarUnitOfMeasure: null,
      //       harvestUnitOfMeasure: null,
      //       grapeVariety: {
      //         id: entry.grapeVarietyId,
      //       },
      //     };
      //   else
      //     pomObj = {
      //       executedNumberFrom: entry.executedNumberFrom,
      //       executedNumberTo: entry.executedNumberTo,
      //       vineyardRow: {
      //         id: lokID,
      //       },
      //       description: "",
      //       harvestGrapeConditions: null,
      //       harvestQuantity: null,
      //       harvestQuantityPerPlant: null,
      //       harvestSugarInGrape: null,
      //       harvestSugarUnitOfMeasure: null,
      //       harvestUnitOfMeasure: null,
      //       grapeVariety: {
      //         id: entry.grapeVarietyId,
      //       },
      //     };

      //   _this.objVineyardOperationRows.push(pomObj);

      //   _this.povrsina = _this.povrsina +
      //           (Number(entry.distanceBetweenRows) *
      //             (entry.executedNumberTo - entry.executedNumberFrom + 1) *
      //             Number(entry.distanceBetweenPlants));
      // });

      // this.objVineyardOperationBlock = blocks;

      // this.objVineyardOperationExecution.surface = this.povrsina;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    submitVreme(event) {
      event.preventDefault();
      let bool = true;

      let niz = this.timeModalNew.split(":");

      if (niz.length === 2) {
        if (
          Number(niz[0]) >= 0 &&
          Number(niz[0]) < 24 &&
          Number(niz[1]) >= 0 &&
          Number(niz[1]) < 60
        )
          bool = true;
        else bool = false;
      } else bool = false;

      if (bool) this.$refs.menuModal2New.save(this.timeModalNew);
      else {
        alert("Vreme nije dobro uneto, format mora biti ČČ:MM.");
        this.timeModalNew = "00:00";
      }
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    getAllOperations(naziv) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation/type/PRUNING",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.operation_items = response.data;

          if (naziv !== undefined && naziv !== null) {
            let index;

            index = this.operation_items.findIndex((x) => x.name === naziv);

            if (index >= 0) this.operation_select = this.operation_items[index];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation/type/PRUNING",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.operation_items = response.data;

                      if (naziv !== undefined && naziv !== null) {
                        let index;

                        index = this.operation_items.findIndex(
                          (x) => x.name === naziv
                        );

                        if (index >= 0)
                          this.operation_select = this.operation_items[index];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllTipoviRezidbe(naziv) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_pruning_type",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.pruning_items = response.data;

          if (naziv !== undefined && naziv !== null) {
            let index;

            index = this.pruning_items.findIndex((x) => x.name === naziv);

            if (index >= 0) this.pruning_select = this.pruning_items[index];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_pruning_type",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.pruning_items = response.data;

                      if (naziv !== undefined && naziv !== null) {
                        let index;

                        index = this.pruning_items.findIndex(
                          (x) => x.name === naziv
                        );

                        if (index >= 0)
                          this.pruning_select = this.pruning_items[index];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllUzgojniOblik(naziv) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_breeding_type",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.breeding_items = response.data;

          if (naziv !== undefined && naziv !== null) {
            let index;

            index = this.breeding_items.findIndex((x) => x.name === naziv);

            if (index >= 0) this.breeding_select = this.breeding_items[index];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_breeding_type",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.breeding_items = response.data;

                      if (naziv !== undefined && naziv !== null) {
                        let index;

                        index = this.breeding_items.findIndex(
                          (x) => x.name === naziv
                        );

                        if (index >= 0)
                          this.breeding_select = this.breeding_items[index];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    newSifarnik() {
      var complexObjectGroup;

      complexObjectGroup = {
        id: this.id_vineyard,
      };

      var complexObjectGlobal;
      if (this.objVineyardOperationBlock.length !== 0)
        complexObjectGlobal = {
          vineyard: complexObjectGroup,
          vineyardOperation: {
            id: this.operation_select.id,
          },
          vineyardPruningType: {
            id: this.pruning_select.id,
          },
          vineyardBreedingType: {
            id: this.breeding_select.id,
          },
          vineyardOperationBlocks: this.objVineyardOperationBlock,
          vineyardOperationTables: this.objVineyardOperationTables,
          vineyardOperationRows: this.objVineyardOperationRows,
          vineyardOperationMechanizations:
            this.objVineyardOperationMechanizationsSave,
          vineyardOperationWorkForces: this.objVineyardOperationWorkForcesSave,
          vineyardOperationMaterials:
            this.objMaterialFromWarehouseDocumentItemsSave,
          temperature: this.temperatura,
          duration: this.convertTimeToMinute(this.timeModalNew),
          weatherConditions: this.vremenski_uslovi,
          date: this.date + "T" + this.time,
          description: this.opis_zasada,
          surface: this.povrsina,
        };
      else
        complexObjectGlobal = {
          vineyard: complexObjectGroup,
          vineyardOperation: {
            id: this.operation_select.id,
          },
          vineyardPruningType: {
            id: this.pruning_select.id,
          },
          vineyardBreedingType: {
            id: this.breeding_select.id,
          },
          vineyardOperationBlocks: [],
          vineyardOperationRows: this.objVineyardOperationRows,
          vineyardOperationMechanizations:
            this.objVineyardOperationMechanizationsSave,
          vineyardOperationWorkForces: this.objVineyardOperationWorkForcesSave,
          vineyardOperationMaterials:
            this.objMaterialFromWarehouseDocumentItemsSave,
          temperature: this.temperatura,
          duration: this.convertTimeToMinute(this.timeModalNew),
          weatherConditions: this.vremenski_uslovi,
          date: this.date + "T" + this.time,
          description: this.opis_zasada,
          surface: this.povrsina,
        };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/create",
          complexObjectGlobal,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // this.clear();

          this.getAllSifarnikInit(response.data.id);

          this.ID = response.data.id;
          this.datum_operacije = this.date + "T" + this.time;

          // alert("Snimanje ručne obrade je uspešno izvršena.");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/create",
                      complexObjectGlobal,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllSifarnikInit(response.data.id);

                      this.ID = response.data.id;
                      this.datum_operacije = this.date + "T" + this.time;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObjectGroup;

      complexObjectGroup = {
        id: this.id_vineyard,
      };

      var complexObjectGlobal;
      if (this.objVineyardOperationBlock.length !== 0)
        complexObjectGlobal = {
          id: this.ID,
          vineyard: complexObjectGroup,
          vineyardOperation: {
            id: this.operation_select.id,
          },
          vineyardPruningType: {
            id: this.pruning_select.id,
          },
          vineyardBreedingType: {
            id: this.breeding_select.id,
          },
          vineyardOperationBlocks: this.objVineyardOperationBlock,
          vineyardOperationTables: this.objVineyardOperationTables,
          vineyardOperationRows: this.objVineyardOperationRows,
          vineyardOperationMechanizations:
            this.objVineyardOperationMechanizations,
          vineyardOperationWorkForces: this.objVineyardOperationWorkForces,
          vineyardOperationMaterials:
            this.objMaterialFromWarehouseDocumentItems,
          temperature: this.temperatura,
          duration: this.convertTimeToMinute(this.timeModalNew),
          weatherConditions: this.vremenski_uslovi,
          date: this.date + "T" + this.time,
          description: this.opis_zasada,
          surface: this.objVineyardOperationExecution.surface,
        };
      else
        complexObjectGlobal = {
          id: this.ID,
          vineyard: complexObjectGroup,
          vineyardOperation: {
            id: this.operation_select.id,
          },
          vineyardPruningType: {
            id: this.pruning_select.id,
          },
          vineyardBreedingType: {
            id: this.breeding_select.id,
          },
          vineyardOperationBlocks: [],
          vineyardOperationRows: this.objVineyardOperationRows,
          vineyardOperationMechanizations:
            this.objVineyardOperationMechanizations,
          vineyardOperationWorkForces: this.objVineyardOperationWorkForces,
          vineyardOperationMaterials:
            this.objMaterialFromWarehouseDocumentItems,
          temperature: this.temperatura,
          duration: this.convertTimeToMinute(this.timeModalNew),
          weatherConditions: this.vremenski_uslovi,
          date: this.date + "T" + this.time,
          description: this.opis_zasada,
          surface: this.objVineyardOperationExecution.surface,
        };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/update",
          complexObjectGlobal,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.clear();

          // this.getAllSifarnikInit(this.ID);

          // alert("Izmena ručne obrade je uspešno izvršena.");
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/update",
                      complexObjectGlobal,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.clear();

                      // this.getAllSifarnikInit(this.ID);

                      // alert("Izmena ručne obrade je uspešno izvršena.");
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnikInit(idSadnje) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/" +
            idSadnje,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);
          if (this.id_vineyard === undefined)
            this.id_vineyard = response.data.vineyard.id;

          this.operation_select = {
            id: response.data.vineyardOperation.id,
          };

          if (
            response.data.vineyardPruningType !== undefined &&
            response.data.vineyardPruningType !== null
          )
            this.pruning_select = {
              id: response.data.vineyardPruningType.id,
            };

          if (
            response.data.vineyardBreedingType !== undefined &&
            response.data.vineyardBreedingType !== null
          )
            this.breeding_select = {
              id: response.data.vineyardBreedingType.id,
            };

          this.date = response.data.date.split("T")[0];
          this.time = this.formatTime(response.data.date.split("T")[1]);

          this.datum_operacije = this.date + "T" + this.time;

          this.temperatura = response.data.temperature;

          if (response.data.duration !== null)
            this.timeModalNew = this.convertMinToTime(response.data.duration);

          this.vremenski_uslovi = response.data.weatherConditions;
          this.opis_zasada = response.data.description;

          this.objVineyardPlaint = response.data;

          let _this = this;
          var counts = {};
          var rows = {};

          _this.broj_kalemova = 0;

          _this.objVineyardPlaint.vineyardOperationRows.forEach(function (e) {
            _this.broj_kalemova =
              _this.broj_kalemova +
              Number(e.executedNumberTo - e.executedNumberFrom + 1);

            counts[e.grapeVariety.id] = 1 + (counts[e.grapeVariety.id] || 0);

            rows[e.vineyardRow.id] = 1 + (rows[e.vineyardRow.id] || 0);
            // rows[e.id] = 1 + (rows[e.id] || 0);
          });

          _this.broj_sorti = Object.keys(counts).length;
          _this.broj_redova = Object.keys(rows).length;

          _this.povrsina =
            Math.round(_this.objVineyardPlaint.surface * 100) / 100;

          this.objVineyardOperationWorkForces =
            response.data.vineyardOperationWorkForces;
          this.objVineyardOperationMechanizations =
            response.data.vineyardOperationMechanizations;
          this.objMaterialFromWarehouseDocumentItems =
            response.data.vineyardOperationMaterials;

          this.objVineyardOperationRows = response.data.vineyardOperationRows;

          this.objVineyardOperationBlock =
            response.data.vineyardOperationBlocks;

          this.objVineyardOperationTables =
            response.data.vineyardOperationTables;

          let pomObjVineyardOperationExecution = {
            id: null,
            vineyardOperation: {
              id: null,
            },
            vineyard: {
              id: null,
            },
            date: null,
            vineyardOperationWorkForces: [],
            vineyardOperationMechanizations: [],
            vineyardOperationMaterials: [],
            vineyardOperationRows: response.data.vineyardOperationRows,
            temperature: null,
            duration: null,
            weatherConditions: null,
            description: null,
            vineyardOperationBlocks: response.data.vineyardOperationBlocks,
            vineyardOperationTables: response.data.vineyardOperationTables,
          };

          pomObjVineyardOperationExecution.id = response.data.id;
          pomObjVineyardOperationExecution.vineyardOperation = {
            id: response.data.vineyardOperation.id,
          };

          if (
            response.data.vineyardPruningType !== undefined &&
            response.data.vineyardPruningType !== null
          )
            pomObjVineyardOperationExecution.vineyardPruningType = {
              id: response.data.vineyardPruningType.id,
            };
          else pomObjVineyardOperationExecution.vineyardPruningType = null;

          if (
            response.data.vineyardBreedingType !== undefined &&
            response.data.vineyardBreedingType !== null
          )
            pomObjVineyardOperationExecution.vineyardBreedingType = {
              id: response.data.vineyardBreedingType.id,
            };
          else pomObjVineyardOperationExecution.vineyardBreedingType = null;

          pomObjVineyardOperationExecution.vineyard = {
            id: response.data.vineyard.id,
          };
          pomObjVineyardOperationExecution.date = response.data.date;
          pomObjVineyardOperationExecution.surface = response.data.surface;

          pomObjVineyardOperationExecution.temperature =
            response.data.temperature;
          pomObjVineyardOperationExecution.weatherConditions =
            response.data.weatherConditions;
          pomObjVineyardOperationExecution.description =
            response.data.description;
          pomObjVineyardOperationExecution.duration = response.data.duration;

          this.objVineyardOperationExecution = {
            ...pomObjVineyardOperationExecution,
          };
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(response.data);
                  if (this.id_vineyard === undefined)
                    this.id_vineyard = response.data.vineyard.id;

                  this.operation_select = {
                    id: response.data.vineyardOperation.id,
                  };

                  if (
                    response.data.vineyardPruningType !== undefined &&
                    response.data.vineyardPruningType !== null
                  )
                    this.pruning_select = {
                      id: response.data.vineyardPruningType.id,
                    };

                  if (
                    response.data.vineyardBreedingType !== undefined &&
                    response.data.vineyardBreedingType !== null
                  )
                    this.breeding_select = {
                      id: response.data.vineyardBreedingType.id,
                    };

                  this.date = response.data.date.split("T")[0];
                  this.time = this.formatTime(response.data.date.split("T")[1]);

                  this.datum_operacije = this.date + "T" + this.time;

                  this.temperatura = response.data.temperature;

                  if (response.data.duration !== null)
                    this.timeModalNew = this.convertMinToTime(
                      response.data.duration
                    );

                  this.vremenski_uslovi = response.data.weatherConditions;
                  this.opis_zasada = response.data.description;

                  this.objVineyardPlaint = response.data;

                  let _this = this;
                  var counts = {};
                  var rows = {};

                  _this.broj_kalemova = 0;

                  _this.objVineyardPlaint.vineyardOperationRows.forEach(
                    function (e) {
                      _this.broj_kalemova =
                        _this.broj_kalemova +
                        Number(e.executedNumberTo - e.executedNumberFrom + 1);

                      counts[e.grapeVariety.id] =
                        1 + (counts[e.grapeVariety.id] || 0);

                      rows[e.vineyardRow.id] = 1 + (rows[e.vineyardRow.id] || 0);
                      // rows[e.id] = 1 + (rows[e.id] || 0);
                    }
                  );

                  _this.broj_sorti = Object.keys(counts).length;
                  _this.broj_redova = Object.keys(rows).length;

                  _this.povrsina =
                    Math.round(_this.objVineyardPlaint.surface * 100) / 100;

                  this.objVineyardOperationWorkForces =
                    response.data.vineyardOperationWorkForces;
                  this.objVineyardOperationMechanizations =
                    response.data.vineyardOperationMechanizations;
                  this.objMaterialFromWarehouseDocumentItems =
                    response.data.vineyardOperationMaterials;

                  this.objVineyardOperationRows =
                    response.data.vineyardOperationRows;

                  this.objVineyardOperationBlock =
                    response.data.vineyardOperationBlocks;

                  this.objVineyardOperationTables =
                    response.data.vineyardOperationTables;

                  let pomObjVineyardOperationExecution = {
                    id: null,
                    vineyardOperation: {
                      id: null,
                    },
                    vineyard: {
                      id: null,
                    },
                    date: null,
                    vineyardOperationWorkForces: [],
                    vineyardOperationMechanizations: [],
                    vineyardOperationMaterials: [],
                    vineyardOperationRows: response.data.vineyardOperationRows,
                    temperature: null,
                    duration: null,
                    weatherConditions: null,
                    description: null,
                    vineyardOperationBlocks:
                      response.data.vineyardOperationBlocks,
                    vineyardOperationTables:
                      response.data.vineyardOperationTables,
                  };

                  pomObjVineyardOperationExecution.id = response.data.id;
                  pomObjVineyardOperationExecution.vineyardOperation = {
                    id: response.data.vineyardOperation.id,
                  };

                  if (
                    response.data.vineyardPruningType !== undefined &&
                    response.data.vineyardPruningType !== null
                  )
                    pomObjVineyardOperationExecution.vineyardPruningType = {
                      id: response.data.vineyardPruningType.id,
                    };
                  else
                    pomObjVineyardOperationExecution.vineyardPruningType = null;

                  if (
                    response.data.vineyardBreedingType !== undefined &&
                    response.data.vineyardBreedingType !== null
                  )
                    pomObjVineyardOperationExecution.vineyardBreedingType = {
                      id: response.data.vineyardBreedingType.id,
                    };
                  else
                    pomObjVineyardOperationExecution.vineyardBreedingType =
                      null;

                  pomObjVineyardOperationExecution.vineyard = {
                    id: response.data.vineyard.id,
                  };
                  pomObjVineyardOperationExecution.date = response.data.date;
                  pomObjVineyardOperationExecution.surface =
                    response.data.surface;

                  pomObjVineyardOperationExecution.temperature =
                    response.data.temperature;
                  pomObjVineyardOperationExecution.weatherConditions =
                    response.data.weatherConditions;
                  pomObjVineyardOperationExecution.description =
                    response.data.description;
                  pomObjVineyardOperationExecution.duration =
                    response.data.duration;

                  this.objVineyardOperationExecution = {
                    ...pomObjVineyardOperationExecution,
                  };
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if(this.id_vineyard === undefined || this.id_vineyard === null){
          alert("Snimanje nije izvršeno, nije izabran vinograd.");

          const childElement = document.getElementById("closeModalMagacinBtn");  
          console.log(childElement)  
          childElement.click();

          this.$router.push({name: "vineyards"});
        }
        else {
          if (!this.$refs.element2.validate()) this.pruning_select = null;

          if (!this.$refs.element3.validate()) this.breeding_select = null;

          // if (this.objVineyardOperationRows.length > 0) {
          if (this.$refs.form1.validate()) {
            if (this.ID != "" && this.ID != 0) this.changeSifarnik();
            else this.newSifarnik();
          }
        }
      // } else alert("Snimanje nije izvršeno, nisu izabrani redovi.");
    },
    clear() {
      this.timeModalNew = undefined;

      this.objVineyardOperationRows = [];
      
      this.ID_grape_variety = 0;
      this.ID_reda = 0;

      this.$refs.form.reset();
      this.$refs.element2.reset();
      this.$refs.element3.reset();
      this.$refs.element4.reset();

      this.setTime();
      
      if (this.ID > 0) this.getAllSifarnikInit(this.ID);
      else {
        this.setDate();
      }

      this.sufiks = "";
    },
  },
  mounted() {
    this.vinarija = daLiJeVinarija();

    if(this.vinarija)
      this.tekstBiljka = "Broj čokota";
    else
      this.tekstBiljka = "Broj biljaka";

    this.lokVinarija = localStorage.getItem("vinarija");

    this.clear();

    this.getAllOperations();
    this.getAllTipoviRezidbe();
    this.getAllUzgojniOblik();

    serverBus.$on("vy_rezidba", (id_vinograda, item) => {
      

      if (item !== null && item !== undefined) {
        if (item.edit !== undefined && item.edit !== null)
          this.izmena = item.edit;
        else this.izmena = true;
      } else this.izmena = true;

      if (id_vinograda !== 0 && id_vinograda !== "0")
        this.id_vineyard = id_vinograda;
      else this.id_vineyard = undefined;

      console.log(this.ID_grape_variety);

      if (item !== null && item !== undefined) {
        this.ID = item.id;
        this.getAllSifarnikInit(item.id);
      }
    });
  },
};
</script>


<style lang="scss" scoped>
.addingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

div.v-subheader {
  padding-top: 20px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin: 0px;
}

#HeaderRow {
  font-size: 18px;
  color: #6d001a;
  padding-left: 15px;
}
@import "./../assets/sass/parts/modalStyles";

.coupageItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

#FloatingButton {
  // position: absolute;
  width: 48px;
  height: 48px;
  font-size: 25px;
  border-radius: 50%;

  background-color: #018389;
  background-image: url("../assets/menuIcons/vinograd.svg");
  background-position: center;

  &:active,
  &:focus {
    box-shadow: none;
  }
}

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

#HistoryButton {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 14px;
      top: -2px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}
.div_prozorce {
  border-color: white !important;
  border-style: solid !important;
  height: 100% !important;
  border-radius: 15px !important;
}

.gornji_text {
  font-size: 18px !important;
  margin: 0px !important;
  padding-top: 10px !important;
  text-align: center;
}

.donji_text {
  font-size: 12px !important;
  text-align: center;
  margin: 0px !important;
  line-height: 0.1 !important;
}
</style>